import { Avatar, AvatarProps, forwardRef } from '@chakra-ui/react';
import { useCreatorStore } from '~/store/creator.store';
import { ICreator } from '~/types';

type CreatorAvatarProps = AvatarProps & {
  creator?: ICreator;
};

export const CreatorAvatar = forwardRef<CreatorAvatarProps, 'span'>(
  ({ creator, src, ...props }, ref) => {
    const creatorStore = useCreatorStore();

    /**
     * CroppedAvatar will use temporal blob that is generated from the upload component
     */
    const croppedAvatarURL = creatorStore.getCropperImage(creator?.id ?? '');

    return <Avatar {...props} src={croppedAvatarURL || src} ref={ref} />;
  },
);
